import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  NgZone,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ApiService } from '../../shared/services/api.service';
import { CookieService } from '../../shared/services/cookie.service';
import { secureStorage } from '../../shared/services/secure-storage.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UserAddressComponent } from '../user-address/user-address.component';
import { WishlistComponent } from '../wishlist/wishlist.component';
import { NotificationAlertComponent } from '../notification-alert/notification-alert.component';
import { CouponsOffersComponent } from '../coupons-offers/coupons-offers.component';
import { LoaderService } from '../../shared/services/loader.service';
import { OrdersComponent } from '../orders/orders.component';
import { ScrapCertificateComponent } from '../scrap-certificate/scrap-certificate.component';
import { MyGarageComponent } from '../../my-garage/my-garage.component';
import { ProfileFaqComponent } from '../profile-faq/profile-faq.component';
import { CustomerSupportComponent } from '../customer-support/customer-support.component';
import { isUserProfileSection } from '../../shared/constants/user-profile-navigation';
import { GarageShareService } from '../../shared/services/garage-share.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LogoutDetectionService } from '../../shared/services/logout-detection.service';
import { TokenService } from '../../shared/services/token.service';
import { BuyerVerificationService } from '../../shared/services/buyer-verification.service';
import {
  BuyerVerificationData,
  GstinItem,
  INDIAN_SHOP_LICENSE_STATES,
  VerificationProfile,
} from '../../shared/models/buyer-verification.models';

type BusinessVerificationType = 'gstin' | 'udyam' | 'shop-license';
type BusinessVerificationStep = 'pan' | BusinessVerificationType;

const UDYAM_PATTERN = /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/;

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    OrdersComponent,
    UserAddressComponent,
    WishlistComponent,
    NotificationAlertComponent,
    CouponsOffersComponent,
    ScrapCertificateComponent,
    MyGarageComponent,
    ProfileFaqComponent,
    CustomerSupportComponent,
  ],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss',
})
export class UserProfileComponent implements OnInit, OnDestroy {
  private readonly emailPattern =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  user: any;
  sub: Subscription = new Subscription();
  selectedSection: string = 'profile';
  userForm: FormGroup = this.initUserForm();
  userData: any;
  isEditing: boolean = false;
  today: string = '';

  // Modal control for Update Mobile Number
  showUpdateMobileModal: boolean = false;
  updatePopupMethod: 'mobile' | 'email' = 'mobile';
  selectedVerificationMethod: 'mobile' | 'email' = 'mobile';
  showverifyMobileModal: boolean = false;
  // Stepper and OTP modal state
  step: number = 1;
  showOtpModal: boolean = false;
  otp: string[] = ['', '', '', '', '', ''];
  otpTimer: number = 59;
  otpInterval: any;
  otpForm: FormGroup = this.initOtpForm();
  otpControls: string[] = ['otp1', 'otp2', 'otp3', 'otp4', 'otp5', 'otp6'];
  btnLabel: any;
  headerLabel: string = 'Verify Existing Account';
  newMobileNumber: any;
  isOtpInvalid: boolean = false;

  // Mobile User Type Dropdown
  showUserTypeDropdown: boolean = false;
  selectedUserType: string | null = null;
  userTypeOptions: string[] = [
    'Individual',
    'Fleet owner',
    'Garage owner',
    'Mechanic',
    'Retailer',
    'End Product Manufacturer',
    'Scrap Recycler',
    'Scrap Trader',
    'Refurbisher',
    'Online',
  ];

  // Email Verification Modal
  showEmailVerifyModal: boolean = false;
  emailOtpForm: FormGroup = this.initEmailOtpForm();
  emailOtpTimer: number = 59;
  emailOtpInterval: any;
  emailOtpControls: string[] = ['otp1', 'otp2', 'otp3', 'otp4', 'otp5', 'otp6'];
  emailBtnLabel: string = 'Add new Number';
  emailHeaderLabel: string = 'Verify Existing Account';
  emailNewMobileNumber: any;
  emailOtpError: boolean = false; // Track email OTP validation error
  emailOtp: string[] = ['', '', '', '', '', ''];

  email_id: boolean = false;
  newEmailId: any;
  errorMessage: any;

  // Logout confirmation popup
  showLogoutPopup: boolean = false;

  // Date Picker
  showDatePicker: boolean = false;
  isMobile: boolean = false;
  currentCalendarDate: Date = new Date();
  selectedDateValue: Date | null = null;
  showMonthYearPicker: boolean = false;
  selectedYear: number = new Date().getFullYear();
  selectedMonth: number = new Date().getMonth();
  calendarDays: any[] = [];
  dayNames: string[] = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
  monthNames: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  availableYears: number[] = [];

  @ViewChild('emailInput') emailInput!: ElementRef;
  @ViewChild('mobileInput') mobileInput!: ElementRef;
  @ViewChild('datePickerContainer') datePickerContainer!: ElementRef;

  showEmailError: boolean = false;
  showMobileError: boolean = false;

  // Track if new mobile/email fields are valid and filled
  isNewMobileValid: boolean = false;
  isNewEmailValid: boolean = false;

  // Business verification (PAN → GSTIN / Shop License)
  showBusinessVerificationModal = false;
  businessVerificationStep: BusinessVerificationStep | null = null;
  readonly businessVerificationTypes: readonly BusinessVerificationType[] = [
    'gstin',
    // 'udyam',
    // 'shop-license',
  ];
  private requestedBusinessStep: BusinessVerificationType | null = null;
  private autoFetchUdyam = false;
  private businessData: BuyerVerificationData | null = null;
  businessPanNumber = '';
  businessFullName = '';
  businessLoading = false;
  businessVerificationError = '';
  businessPanTouched = false;
  businessFullNameTouched = false;
  gstins: GstinItem[] = [];
  gstItems: GstinItem[] = [];
  udyamItems: GstinItem[] = [];
  udyamItem: GstinItem | null = null;
  selectedGstin: GstinItem | null = null;
  gstinLoading = false;
  gstinErrorMessage = '';
  readonly shopLicenseStates = INDIAN_SHOP_LICENSE_STATES;
  udyamNumber = '';
  udyamNumberTouched = false;
  udyamLoading = false;
  udyamErrorMessage = '';
  shopLicenseNumber = '';
  shopLicenseState = '';
  shopLicenseCommencementDate = '';
  shopLicenseDistrict = '';
  shopLicenseLoading = false;
  shopLicenseErrorMessage = '';
  shopLicenseNumberTouched = false;
  shopLicenseStateTouched = false;
  shopLicenseCommencementDateTouched = false;
  shopLicenseDistrictTouched = false;

  constructor(
    private garageShareService: GarageShareService,
    private apiService: ApiService,
    private fb: FormBuilder,
    private ssrcookieService: CookieService,
    private localstorage: secureStorage,
    private loaderService: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private logoutDetectionService: LogoutDetectionService,
    private tokenService: TokenService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private buyerVerificationService: BuyerVerificationService,
  ) {
    this.loadUserData();
  }

  ngOnInit() {
    // set today's date for max attribute on DOB field
    this.today = this.getTodayString();
    this.checkScreenSize();
    this.initializeDatePicker();
    this.getUserDetails();
    // Set initial section based on current route with a small delay to ensure router is ready
    setTimeout(() => {
      this.setInitialSection();
    }, 0);

    this.sub.add(
      this.route.queryParamMap.subscribe(() => {
        this.setInitialSection();
      }),
    );
  }

  private setInitialSection(): void {
    const section = this.route.snapshot.queryParamMap.get('section');
    if (isUserProfileSection(section)) {
      this.selectedSection = section;
      return;
    }

    this.selectedSection = 'profile';
  }

  private initUserForm(): FormGroup {
    // Calculate default date of birth (18 years ago)
    const today = new Date();
    const eighteenYearsAgo = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate(),
    );
    const defaultDob = eighteenYearsAgo.toISOString().split('T')[0]; // Format: yyyy-mm-dd

    const form = this.fb.group({
      firstName: ['', [Validators.required, Validators.pattern('^[A-Za-z]+$')]],
      lastName: ['', [Validators.required, Validators.pattern('^[A-Za-z]+$')]],
      mobileNumber: [''],
      emailId: ['', [this.optionalEmailValidator()]],
      userType: [''],
      dateOfBirth: [defaultDob], // Set default to 18 years ago
    });

    // Initial state: not editing → disable all editable fields
    form.get('firstName')?.disable();
    form.get('lastName')?.disable();
    form.get('dateOfBirth')?.disable();
    form.get('userType')?.disable();
    form.get('emailId')?.disable();
    // Mobile requires special flow and stays disabled unless updated via modal
    form.get('mobileNumber')?.disable();

    return form;
  }

  private optionalEmailValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = (control.value || '').trim();
      if (!value) {
        return null;
      }
      return this.emailPattern.test(value) ? null : { invalidEmail: true };
    };
  }

  private getTodayString(): string {
    const now = new Date();
    const timezoneOffsetMs = now.getTimezoneOffset() * 60000;
    const localIso = new Date(now.getTime() - timezoneOffsetMs).toISOString();
    return localIso.split('T')[0];
  }

  private formatDateToDDMMYYYY(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  private formatDateToYYYYMMDD(dateString: string): string {
    if (!dateString) return '';

    // Handle ISO strings like '2002-01-08T00:00:00' (with or without timezone)
    if (dateString.includes('T')) {
      return dateString.split('T')[0];
    }

    // Already in yyyy-mm-dd format
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }

    // Convert from dd/mm/yyyy format
    if (dateString.includes('/')) {
      const parts = dateString.split('/');
      if (parts.length === 3) {
        const day = parts[0].padStart(2, '0');
        const month = parts[1].padStart(2, '0');
        const year = parts[2];
        return `${year}-${month}-${day}`;
      }
    }

    // Fallback: try to parse and format to local yyyy-mm-dd
    const parsed = new Date(dateString);
    if (!isNaN(parsed.getTime())) {
      const tzOffsetMs = parsed.getTimezoneOffset() * 60000;
      const localIso = new Date(parsed.getTime() - tzOffsetMs).toISOString();
      return localIso.split('T')[0];
    }

    return '';
  }

  onDateOfBirthChange(event: any): void {
    const dateValue = event.target.value; // yyyy-mm-dd from input[type="date"]
    if (dateValue) {
      // Keep the control value in yyyy-mm-dd so the date input can display it
      this.userForm.patchValue({ dateOfBirth: dateValue });
    }
  }

  private initOtpForm(): FormGroup {
    return this.fb.group({
      otp1: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp2: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp3: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp4: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp5: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp6: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
    });
  }

  private initEmailOtpForm(): FormGroup {
    return this.fb.group({
      otp1: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp2: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp3: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp4: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp5: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp6: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
    });
  }

  private loadUserData() {
    // Try to load user data from localStorage first
    const storedUserData = localStorage.getItem('userData1');

    if (storedUserData) {
      const parsedData = JSON.parse(storedUserData);
      this.email_id = parsedData?.email_id ? true : false;
      this.updateUserData(parsedData);
    }

    // Also load from cookie service
    const cookieUserData = this.ssrcookieService.getItem('eol_user');
    if (cookieUserData) {
      const parsedCookieData = JSON.parse(cookieUserData);
      this.email_id = parsedCookieData?.email_id ? true : false;
      this.updateUserData(parsedCookieData);
    }
  }

  private updateUserData(data: any) {
    this.user = data;
    this.userData = data;

    // Keep date in yyyy-mm-dd so it binds to input[type='date']
    let formattedDob = '';
    if (data?.dob) {
      formattedDob = this.formatDateToYYYYMMDD(data.dob);
    }

    this.userForm.patchValue({
      firstName: data?.first_name || '',
      lastName: data?.last_name || '',
      mobileNumber: data?.phone_number || '',
      emailId: data?.email_id || '',
      userType: data?.user_type || '',
      dateOfBirth: formattedDob,
    });
  }

  getUserDetails(): void {
    const payload = {};
    this.loaderService.show();
    this.sub.add(
      this.apiService.getUserDetails(payload).subscribe({
        next: (res) => {
          // Update email_id property
          this.email_id = res?.data?.email_id ? true : false;
          this.updateUserData(res?.data);
          // Update localStorage and cookies with latest data
          localStorage.setItem('userData1', JSON.stringify(res?.data));
          this.ssrcookieService.setItem('eol_user', JSON.stringify(res?.data));
          this.loaderService.hide();
        },
        error: (err) => {
          console.error('Failed to fetch user details', err);
          this.loaderService.hide();
        },
      }),
    );
  }

  setSection(section: string) {
    this.selectedSection = section;

    if (section === 'profile') {
      this.router.navigate(['/user-profile'], {
        queryParams: { section: null },
        queryParamsHandling: 'merge',
        replaceUrl: false,
      });
      return;
    }

    this.isEditing = false;
    this.router.navigate(['/user-profile'], {
      queryParams: { section },
      replaceUrl: false,
    });
  }

  get initial() {
    return this.user?.firstName?.charAt(0)?.toUpperCase() || '';
  }

  get fullName() {
    return `${this.user?.first_name || ''} ${this.user?.last_name || ''}`;
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
    if (this.isEditing) {
      if (!this.isPanVerified) {
        this.userForm.get('firstName')?.enable();
        this.userForm.get('lastName')?.enable();
      }
      this.userForm.get('dateOfBirth')?.enable();
      this.userForm.get('userType')?.enable();
      if (!this.email_id) {
        this.userForm.get('emailId')?.enable();
      }
    } else {
      this.userForm.get('firstName')?.disable();
      this.userForm.get('lastName')?.disable();
      this.userForm.get('dateOfBirth')?.disable();
      this.userForm.get('userType')?.disable();
      this.userForm.get('emailId')?.disable();
      this.updateUserData(this.userData);
    }
  }

  onNameInput(event: Event, fieldName: string) {
    if (this.isPanVerified) return;
    const input = event.target as HTMLInputElement;
    if (!input) return;

    const value = input.value;
    // Remove any non-alphabetic characters (including spaces, numbers, special characters)
    const filteredValue = value.replace(/[^A-Za-z]/g, '');

    // Update input value to only contain alphabets
    if (value !== filteredValue) {
      input.value = filteredValue;

      // Update form control value
      if (fieldName === 'firstName') {
        this.userForm.patchValue(
          { firstName: filteredValue },
          { emitEvent: false },
        );
      } else if (fieldName === 'lastName') {
        this.userForm.patchValue(
          { lastName: filteredValue },
          { emitEvent: false },
        );
      }
    }
  }

  openUpdateMobileModal(method: 'mobile' | 'email') {
    // Reset all states first
    this.step = 1;
    this.otpTimer = 59;
    this.otpForm.reset();
    this.errorMessage = '';
    this.newMobileNumber = '';
    this.newEmailId = '';

    // Set what we're updating (mobile or email)
    this.updatePopupMethod = method;

    // Default verification method to mobile (user can change via radio buttons)
    this.selectedVerificationMethod = 'mobile';

    // Reset validation flags
    this.isNewMobileValid = false;
    this.isNewEmailValid = false;
    this.showMobileError = false;
    this.showEmailError = false;

    // Clear any existing intervals
    if (this.otpInterval) {
      clearInterval(this.otpInterval);
    }

    // Open modal
    this.showUpdateMobileModal = true;
  }

  closeUpdateMobileModal() {
    this.showUpdateMobileModal = false;

    // Reset all states
    this.step = 1;
    this.otpTimer = 59;
    this.otpForm.reset();
    this.errorMessage = '';
    this.newMobileNumber = '';
    this.newEmailId = '';
    this.btnLabel = 'Add new Number';

    // Reset validation flags
    this.isNewMobileValid = false;
    this.isNewEmailValid = false;
    this.showMobileError = false;
    this.showEmailError = false;

    // Clear intervals
    if (this.otpInterval) {
      clearInterval(this.otpInterval);
    }
  }

  proceedUpdateMobile() {
    // Keep updatePopupMethod and selectedVerificationMethod separate
    // updatePopupMethod = what we're updating (mobile or email)
    // selectedVerificationMethod = how we verify (via mobile or email)
    this.updateSendOtp();
  }

  startOtpTimer() {
    this.otpTimer = 59;
    if (this.otpInterval) clearInterval(this.otpInterval);

    const timer = setInterval(() => {
      this.ngZone.run(() => {
        if (this.otpTimer > 0) {
          this.otpTimer--;
        } else {
          this.otpTimer = 0;
          clearInterval(timer);
        }
        // Ensure UI updates immediately on each tick
        this.cdr.detectChanges();
      });
    }, 1000);

    // Store the interval reference for cleanup
    this.otpInterval = timer;
  }

  closeOtpModal() {
    this.showOtpModal = false;
    this.step = 1;
    this.btnLabel = 'Add new Number';

    // this.btnLabel = this.updatePopupMethod === 'mobile' ? 'Add new Number' : 'Add new email';

    this.otpForm.reset();
    if (this.otpInterval) {
      clearInterval(this.otpInterval);
    }
  }

  onInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    const value = input.value;

    // Clear invalid OTP flag when user starts typing
    this.isOtpInvalid = false;
    this.errorMessage = '';

    // Only allow numbers
    if (value && /^[0-9]$/.test(value)) {
      // Move to next input if available
      if (index < this.otpControls.length - 1) {
        const nextInput = document.querySelector(
          `input[data-index="${index + 1}"]`,
        ) as HTMLInputElement;
        if (nextInput) {
          nextInput.focus();
        }
      }
    } else {
      // Clear invalid input
      input.value = '';
    }
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    // Handle backspace
    if (event.key === 'Backspace' && index > 0 && !input.value) {
      const prevInput = document.querySelector(
        `input[data-index="${index - 1}"]`,
      ) as HTMLInputElement;
      if (prevInput) {
        prevInput.focus();
      }
    }
  }

  otpInvalid(): boolean {
    return this.otp.some((d) => !d);
  }

  verifyOtp() {
    // Move to next step after verification
    if (this.step === 1) {
      this.updateVerifyOtp();
    } else if (this.step === 2) {
      this.newUpdateSendOtp();
      // Restart timer for new number verification
    } else if (this.step === 3) {
      this.newUpdateVerifyOtp();
    }

    //   if (this.updatePopupMethod === 'email') {
    //   const emailValue = this.newUpdateForm.get('newEmail')?.value;
    //   if (!emailValue || this.newUpdateForm.get('newEmail')?.invalid) {
    //     this.showEmailError = true;
    //     return;
    //   }
    //   this.newEmailId = emailValue;
    // }

    // if (this.updatePopupMethod === 'mobile') {
    //   const mobileValue = this.newUpdateForm.get('newMobile')?.value;
    //   if (!mobileValue || this.newUpdateForm.get('newMobile')?.invalid) {
    //     this.showMobileError = true;
    //     return;
    //   }
    //   this.newMobileNumber = mobileValue;
    // }
  }

  clickBtnLabel() {
    if (this.step === 1) {
      // First OTP verification completed
      this.btnLabel =
        this.updatePopupMethod === 'mobile'
          ? 'Add new Number'
          : 'Add new email';
      this.headerLabel = 'Verify Existing Account';
    } else if (this.step === 2) {
      // New number entered
      this.btnLabel = 'Next';
      this.headerLabel = 'Enter new number';
    } else if (this.step === 3) {
      // Final verification
      this.btnLabel = 'Verify & Update';
      this.headerLabel = 'Verify new number';
    }
  }

  handleBackButton() {
    if (this.step > 1) {
      this.step--;
      // Update button label for the previous step
      this.clickBtnLabel();

      // If going back to step 2, restore the input field values
      if (this.step === 2) {
        this.restoreInputValues();
        // Reset validation flags when going back to step 2
        this.isNewMobileValid = false;
        this.isNewEmailValid = false;
        this.showMobileError = false;
        this.showEmailError = false;
      }
    } else {
      this.closeOtpModal();
    }
  }

  updateSendOtp() {
    const payload = {
      // "new_email_id": this.userForm.value.emailId,
      send_code_via:
        this.selectedVerificationMethod === 'email' ? 'email' : 'mobile',
    };
    this.errorMessage = '';
    this.loaderService.show();
    this.sub.add(
      this.apiService.updateSendOtp(payload).subscribe((res) => {
        if (res.success) {
          this.showOtpModal = true;
          this.step = 1;
          this.btnLabel =
            this.updatePopupMethod === 'mobile'
              ? 'Add new Number'
              : 'Add new email';
          this.startOtpTimer();
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
          this.errorMessage = res?.data?.msg;
        }
      }),
    );
  }

  updateVerifyOtp() {
    const payload = {
      action_type: 'Registered User',
      otp:
        this.otpForm.value.otp1 +
        this.otpForm.value.otp2 +
        this.otpForm.value.otp3 +
        this.otpForm.value.otp4 +
        this.otpForm.value.otp5 +
        this.otpForm.value.otp6,
      send_code_via:
        this.selectedVerificationMethod === 'email' ? 'email' : 'mobile',
    };
    this.errorMessage = '';
    this.isOtpInvalid = false; // Reset flag
    this.loaderService.show();
    this.sub.add(
      this.apiService.updateVerifyOtp(payload).subscribe((res) => {
        if (res.success) {
          this.step = 2;
          this.btnLabel = 'Next';
          this.headerLabel = 'Enter new number';
          this.otpForm.reset();
          this.isOtpInvalid = false;

          // Reset validation flags when moving to step 2
          this.isNewMobileValid = false;
          this.isNewEmailValid = false;
          this.showMobileError = false;
          this.showEmailError = false;

          this.loaderService.hide();
        } else {
          this.errorMessage = res?.data?.msg;
          this.isOtpInvalid = true; // Set flag for invalid OTP
          this.loaderService.hide();
        }
      }),
    );
  }

  newUpdateVerifyOtp() {
    const payload = {
      action_type: 'New User',
      new_phone_number: this.newMobileNumber,
      new_email_id: this.newEmailId,
      otp:
        this.otpForm.value.otp1 +
        this.otpForm.value.otp2 +
        this.otpForm.value.otp3 +
        this.otpForm.value.otp4 +
        this.otpForm.value.otp5 +
        this.otpForm.value.otp6,
    };
    this.errorMessage = '';
    this.isOtpInvalid = false; // Reset flag
    this.loaderService.show();
    this.sub.add(
      this.apiService.updateVerifyOtp(payload).subscribe((res) => {
        if (res.success) {
          this.isOtpInvalid = false;

          if (this.newMobileNumber) {
            this.tokenService.storeAuthData({
              access_token: res?.data?.token['access_token'],
              refresh_token: res?.data?.token['refresh_token'],
              user_code: res?.data?.user_code,
              expires_in: res?.data?.token['expires_in'],
            });

            // Store additional user data
            this.ssrcookieService.setItem('eol_user', JSON.stringify(res.data));
            this.localstorage.setItem('eol_user', JSON.stringify(res.data));

            // Store phone number and OTP for registration
            this.updateStorageWithNewData(res.data);
            this.closeOtpModal();
            this.closeUpdateMobileModal();
            this.updateUserData(res.data);
            this.loaderService.hide();
          } else {
            this.updateStorageWithNewData(res.data);
            this.closeOtpModal();
            this.closeUpdateMobileModal();
            this.updateUserData(res.data);
            this.loaderService.hide();
          }
        } else {
          this.errorMessage = res?.data?.msg;
          this.isOtpInvalid = true; // Set flag for invalid OTP
          this.loaderService.hide();
        }
      }),
    );
  }

  validateEmail(value: string) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = regex.test(value.trim());
    this.showEmailError = !isValid;
    this.isNewEmailValid = isValid;
  }

  // Method to validate on input change for mobile
  onMobileInputChange(event: any) {
    const value = event.target.value;
    if (value.trim().length === 0) {
      this.isNewMobileValid = false;
      this.showMobileError = false;
    } else {
      this.validateMobile(value);
    }
  }

  // Method to check if the button should be disabled
  isButtonDisabled(): boolean {
    if (this.step === 1 || this.step === 3) {
      return !this.otpForm.valid;
    } else if (this.step === 2) {
      if (this.updatePopupMethod === 'mobile') {
        return !this.isNewMobileValid;
      } else if (this.updatePopupMethod === 'email') {
        return !this.isNewEmailValid;
      }
    }
    return false;
  }

  validateMobile(value: any) {
    const inputEl = this.mobileInput.nativeElement as HTMLInputElement;
    const regex = /^[6-9]\d{9}$/;
    const isValid =
      regex.test(inputEl.value) && inputEl.value.trim().length === 10;
    this.showMobileError = !isValid;
    this.isNewMobileValid = isValid;
  }

  private updateStorageWithNewData(data: any) {
    if (this.updatePopupMethod === 'mobile') {
      // Update cookie storage
      this.ssrcookieService.setItem(
        'eol_access_token',
        data?.token['access_token'],
      );
      this.ssrcookieService.setItem(
        'eol_ref_token',
        data?.token['refresh_token'],
      );
      this.ssrcookieService.setItem('eol_user_code', data?.user_code);
      this.ssrcookieService.setItem('eol_user', JSON.stringify(data));
      this.ssrcookieService.setItem('user_code', data?.user_code);

      // Update secure storage
      this.localstorage.setItem('eol_ref_token', data?.token['refresh_token']);
      this.localstorage.setItem('eol_user_code', data?.user_code);
      this.localstorage.setItem('user_code', data?.user_code);
      this.localstorage.setItem('eol_user', JSON.stringify(data));

      // Update local storage
      localStorage.removeItem('registrationPhoneNumber');
      localStorage.removeItem('registrationOtp');
      localStorage.setItem('userData', JSON.stringify(data));
      localStorage.setItem('useractive', data?.is_active);
      localStorage.setItem('userData1', JSON.stringify(data));
    }
  }
  onResendClick() {
    if (this.otpTimer > 0) {
      // Optional: You can show toast or console log
      return;
    }
    this.errorMessage = '';
    this.isOtpInvalid = false;
    this.otpForm.reset();
    this.otpControls.forEach((control) => {
      const formControl = this.otpForm.get(control);
      formControl?.setValue('');
      formControl?.markAsPristine();
      formControl?.markAsUntouched();
    });

    // Focus back on the first OTP input for better UX
    setTimeout(() => {
      const firstInput = document.querySelector(
        'input[data-index="0"]',
      ) as HTMLInputElement | null;
      firstInput?.focus();
    });

    this.newUpdateSendOtp();
  }

  newUpdateSendOtp() {
    // Don't allow resending OTP if timer is still running
    if (this.step === 3 && this.otpTimer > 0) {
      return;
    }

    // Only capture values if we're on step 2 (where input fields are visible)
    if (this.step === 2) {
      const mobileInput = (
        document.getElementById('mobile-input') as HTMLInputElement
      )?.value;
      const emailInput = (
        document.getElementById('email-input') as HTMLInputElement
      )?.value;

      // Validate mobile number
      const mobileRegex = /^[6-9]\d{9}$/;
      if (mobileInput) {
        if (!mobileRegex.test(mobileInput)) {
          this.showMobileError = true;
          return;
        } else {
          this.showMobileError = false;
          this.newMobileNumber = mobileInput;
        }
      }
      // Validate email
      if (emailInput) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(emailInput)) {
          this.showEmailError = true;
          return;
        } else {
          this.showEmailError = false;
          this.newEmailId = emailInput;
        }
      }
    }

    const payload = {
      action_type: 'New User',
      new_phone_number: this.newMobileNumber,
      new_email_id: this.newEmailId,
    };
    this.errorMessage = '';
    this.loaderService.show();

    this.sub.add(
      this.apiService.updateSendOtp(payload).subscribe((res) => {
        if (res.success) {
          this.step = 3;
          this.btnLabel = 'Verify & Update';
          this.headerLabel = 'Verify new number';
          this.otpForm.reset();
          this.startOtpTimer();
        } else {
          this.errorMessage = res?.data?.msg;
          // alert(res?.data?.msg);
        }
        this.loaderService.hide();
      }),
    );
  }

  private restoreInputValues() {
    // Use setTimeout to ensure DOM is ready and step 2 is rendered
    setTimeout(() => {
      // Only restore if we're on step 2 where input fields are visible
      if (this.step === 2) {
        // Restore mobile number input value if it exists
        if (this.newMobileNumber) {
          const mobileInput = document.getElementById(
            'mobile-input',
          ) as HTMLInputElement;
          if (mobileInput) {
            mobileInput.value = this.newMobileNumber;
          }
        }

        // Restore email input value if it exists
        if (this.newEmailId) {
          const emailInput = document.getElementById(
            'email-input',
          ) as HTMLInputElement;
          if (emailInput) {
            emailInput.value = this.newEmailId;
          }
        }
      }
    }, 200); // Increased timeout to ensure step 2 is fully rendered
  }

  updateUserDetails() {
    // Mark all fields as touched to show validation errors
    this.userForm.get('firstName')?.markAsTouched();
    this.userForm.get('lastName')?.markAsTouched();

    // Check if form is valid
    if (this.userForm.invalid) {
      return; // Don't submit if form is invalid
    }

    // The control stores yyyy-mm-dd; pass as-is to API
    const formattedDob = this.formatDateToYYYYMMDD(
      this.userForm.value.dateOfBirth,
    );

    const payload = {
      action_type: 'update',
      dob: formattedDob,
      first_name: this.userForm.value.firstName,
      last_name: this.userForm.value.lastName,
      user_type: this.userForm.value.userType,
    };
    this.loaderService.show();
    this.sub.add(
      this.apiService.getUserDetails(payload).subscribe({
        next: (res) => {
          this.loaderService.hide();
          // Update localStorage and cookies with latest data
          localStorage.setItem('userData1', JSON.stringify(res?.data));
          this.ssrcookieService.setItem('eol_user', JSON.stringify(res?.data));
          this.userData = res?.data;
          this.toggleEdit();
        },
        error: (err) => {
          this.loaderService.hide();
          console.error('Failed to fetch user details', err);
        },
      }),
    );
  }

  userLogout() {
    this.showLogoutPopup = true;
  }

  confirmLogout() {
    const payload = {
      refresh_token: this.localstorage.getItem('eol_ref_token'),
      access_token: this.localstorage.getItem('eol_access_token'),
    };

    this.sub.add(
      this.apiService.user_logout(payload).subscribe((res) => {
        this.tokenService.clearAuth();
        // Use the logout detection service to handle logout with refresh
        this.logoutDetectionService.logoutWithRefresh();
      }),
    );
    this.showLogoutPopup = false;
  }

  cancelLogout() {
    this.showLogoutPopup = false;
  }

  // Mobile User Type Dropdown Methods
  openUserTypeDropdown() {
    this.selectedUserType = this.userForm.get('userType')?.value || null;
    this.showUserTypeDropdown = true;
  }

  closeUserTypeDropdown() {
    this.showUserTypeDropdown = false;
    this.selectedUserType = null;
  }

  selectUserTypeOption(option: string) {
    this.selectedUserType = option;
  }

  confirmUserTypeSelection() {
    if (this.selectedUserType) {
      this.userForm.patchValue({ userType: this.selectedUserType });
      this.closeUserTypeDropdown();
    }
  }

  selectUserType(option: string) {
    this.userForm.patchValue({ userType: option });
    this.closeUserTypeDropdown();
  }

  // Email Verification Modal Methods
  openverifyMobileModal() {
    const emailControl = this.userForm.get('emailId');
    if (emailControl?.invalid) {
      emailControl.markAsTouched();
      alert('Please enter a valid email address');
      return;
    }

    const payload = {
      action_type: 'New User',
      new_email_id: this.userForm.value.emailId,
    };
    this.errorMessage = '';
    this.loaderService.show();

    this.sub.add(
      this.apiService.updateSendOtp(payload).subscribe((res) => {
        if (res.success) {
          this.showEmailVerifyModal = true;
          // this.step = 3;
          // this.btnLabel = 'Verify & Update';
          //   this.headerLabel = 'Verify new number';
          //   this.otpForm.reset();
          //   this.startOtpTimer();
          this.loaderService.show();
        } else {
          this.loaderService.show();
          this.errorMessage = res?.data?.msg;
          // alert(res?.data?.msg);
        }
        this.loaderService.hide();
      }),
    );
    this.startEmailOtpTimer();
  }

  // resendEmailOtp() {

  // Handle email input changes
  onEmailInputChange(event: any) {
    const emailValue = (event.target.value || '').trim();
    // this.email_id = emailValue && emailValue.trim() !== '';

    // Add validation for new email during update process
    if (emailValue.length === 0) {
      this.isNewEmailValid = false;
      this.showEmailError = false;
    } else {
      this.validateEmail(emailValue);
    }

    const control = this.userForm.get('emailId');
    control?.setValue(emailValue, { emitEvent: false });
  }

  onEmailFieldBlur(): void {
    const control = this.userForm.get('emailId');
    control?.markAsTouched();
    control?.updateValueAndValidity();
  }

  closeEmailVerifyModal() {
    this.showEmailVerifyModal = false;
    this.emailOtpForm.reset();
    if (this.emailOtpInterval) {
      clearInterval(this.emailOtpInterval);
    }
  }

  startEmailOtpTimer() {
    this.emailOtpTimer = 59;
    if (this.emailOtpInterval) clearInterval(this.emailOtpInterval);

    const timer = setInterval(() => {
      this.ngZone.run(() => {
        if (this.emailOtpTimer > 0) {
          this.emailOtpTimer--;
          this.cdr.markForCheck();
        } else {
          this.emailOtpTimer = 0;
          clearInterval(timer);
          this.cdr.markForCheck();
        }
        // Ensure UI updates immediately on each tick
        this.cdr.detectChanges();
      });
    }, 1000);

    // Store the interval reference for cleanup
    this.emailOtpInterval = timer;
  }

  canResendEmailOtp(): boolean {
    return this.emailOtpTimer === 0;
  }

  resendEmailOtp(): void {
    if (!this.canResendEmailOtp()) {
      return;
    }

    this.errorMessage = '';
    this.emailOtpError = false;
    this.emailOtpForm.reset();
    this.emailOtpControls.forEach((control) => {
      const formControl = this.emailOtpForm.get(control);
      formControl?.setValue('');
      formControl?.markAsPristine();
      formControl?.markAsUntouched();
    });

    setTimeout(() => {
      const firstEmailInput = document.querySelector(
        'input[data-email-index="0"]',
      ) as HTMLInputElement | null;
      firstEmailInput?.focus();
    });

    const payload = {
      action_type: 'New User',
      new_email_id: this.userForm.value.emailId,
    };

    this.loaderService.show();

    this.sub.add(
      this.apiService.updateSendOtp(payload).subscribe((res) => {
        if (res.success) {
          this.startEmailOtpTimer();
        } else {
          this.errorMessage = res?.data?.msg;
          this.cdr.markForCheck();
        }
        this.loaderService.hide();
      }),
    );
  }

  // canResendEmailOtp(): boolean {
  //   return this.emailOtpTimer === 0;
  // }

  // resendEmailOtp(): void {
  //   if (!this.canResendEmailOtp()) {
  //     return;
  //   }

  //   const payload = {
  //     "action_type": "New User",
  //     "new_email_id": this.userForm.value.emailId
  //   };

  //   this.errorMessage = '';
  //   this.loaderService.show();

  //   this.sub.add(this.apiService.updateSendOtp(payload).subscribe((res) => {
  //     if (res.success) {
  //       this.startEmailOtpTimer();
  //     } else {
  //       this.errorMessage = res?.data?.msg;
  //       this.cdr.markForCheck();
  //     }
  //     this.loaderService.hide();
  //   }));
  // }

  onEmailOtpInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    // Clear error state when user starts typing
    if (this.emailOtpError) {
      this.emailOtpError = false;
      this.errorMessage = '';
    }

    const value = input.value;

    // Only allow numbers
    if (value && /^[0-9]$/.test(value)) {
      // Move to next input if available
      if (index < this.emailOtpControls.length - 1) {
        const nextInput = document.querySelector(
          `input[data-email-index="${index + 1}"]`,
        ) as HTMLInputElement;
        if (nextInput) {
          nextInput.focus();
        }
      }
    } else {
      // Clear invalid input
      input.value = '';
    }
  }

  onEmailOtpKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    // Handle backspace
    if (event.key === 'Backspace' && index > 0 && !input.value) {
      const prevInput = document.querySelector(
        `input[data-email-index="${index - 1}"]`,
      ) as HTMLInputElement;
      if (prevInput) {
        prevInput.focus();
      }
    }
  }

  verifyEmailOtp() {
    // Clear previous error state
    this.emailOtpError = false;

    // Handle email OTP verification logic here
    const payload = {
      action_type: 'New User',
      new_email_id: this.userForm.value.emailId,
      otp: Object.values(this.emailOtpForm.value).join(''), //this.otpForm.value.otp1 + this.otpForm.value.otp2 + this.otpForm.value.otp3 + this.otpForm.value.otp4 + this.otpForm.value.otp5 + this.otpForm.value.otp6
    };
    this.errorMessage = '';
    this.loaderService.show();
    this.sub.add(
      this.apiService.updateVerifyOtp(payload).subscribe((res) => {
        if (res.success) {
          this.showEmailVerifyModal = false;
          if (res.data.email_id) {
            this.email_id = true;
          }
          this.getUserDetails();
          this.updateUserData(res.data);
          this.loaderService.hide();
        } else {
          // Set error state for invalid OTP
          this.emailOtpError = true;
          this.errorMessage = res?.data?.msg;
          this.loaderService.hide();
        }
      }),
    );
    // Add your API call logic here
  }

  gotoHome() {
    this.router.navigate(['/home']);
  }

  getBreadcrumbLabel(): string {
    const labels: Record<string, string> = {
      profile: 'Profile',
      orders: 'Orders & Returns',
      'my-garage': 'My Garage',
      address: 'Saved Addresses',
      wishlist: 'My Wishlist',
      coupons: 'Coupons & Offers',
      notifications: 'Notifications',
      'scrap-certificate': 'Scrap Certificate',
      'profile-faq': 'FAQ',
      'customer-support': 'customer Support',
    };
    return labels[this.selectedSection] || 'Profile';
  }

  // Date Picker Methods
  initializeDatePicker() {
    // Generate available years (100 years back from current year)
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= currentYear - 100; i--) {
      this.availableYears.push(i);
    }

    // Initialize with current date or form value
    const formDate = this.userForm.get('dateOfBirth')?.value;
    if (formDate) {
      const date = new Date(formDate);
      if (!isNaN(date.getTime())) {
        this.currentCalendarDate = date;
        this.selectedDateValue = date;
        this.selectedYear = date.getFullYear();
        this.selectedMonth = date.getMonth();
      }
    }

    this.generateCalendar();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 768;
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 768;
    });
  }

  openDatePicker() {
    if (!this.isEditing) return;

    // Check screen size
    this.isMobile = window.innerWidth < 768;

    // Initialize with current form value or 18 years ago
    const formDate = this.userForm.get('dateOfBirth')?.value;
    if (formDate) {
      const date = new Date(formDate);
      if (!isNaN(date.getTime())) {
        this.currentCalendarDate = new Date(date);
        this.selectedDateValue = new Date(date);
        this.selectedYear = date.getFullYear();
        this.selectedMonth = date.getMonth();
      }
    } else {
      // Default to 18 years ago if no date is set
      const today = new Date();
      const eighteenYearsAgo = new Date(
        today.getFullYear() - 18,
        today.getMonth(),
        today.getDate(),
      );
      this.currentCalendarDate = eighteenYearsAgo;
      this.selectedYear = eighteenYearsAgo.getFullYear();
      this.selectedMonth = eighteenYearsAgo.getMonth();
      this.selectedDateValue = eighteenYearsAgo;
    }

    this.showMonthYearPicker = false;
    this.generateCalendar();
    this.showDatePicker = true;
  }

  closeDatePicker() {
    this.showDatePicker = false;
    this.showMonthYearPicker = false;
  }

  generateCalendar() {
    const year = this.currentCalendarDate.getFullYear();
    const month = this.currentCalendarDate.getMonth();

    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = (firstDay.getDay() + 6) % 7; // Convert Sunday=0 to Monday=0

    this.calendarDays = [];

    // Add previous month's trailing days
    if (startingDayOfWeek > 0) {
      const prevMonthLastDay = new Date(year, month, 0).getDate();
      for (let i = startingDayOfWeek - 1; i >= 0; i--) {
        this.calendarDays.push({
          date: prevMonthLastDay - i,
          isOtherMonth: true,
          isSelected: false,
          isToday: false,
          isDisabled: false,
          fullDate: new Date(year, month - 1, prevMonthLastDay - i),
        });
      }
    }

    // Add current month's days
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    for (let day = 1; day <= daysInMonth; day++) {
      const currentDate = new Date(year, month, day);
      currentDate.setHours(0, 0, 0, 0);

      const isSelected =
        this.selectedDateValue &&
        currentDate.getTime() === this.selectedDateValue.getTime();
      const isToday = currentDate.getTime() === today.getTime();
      const isDisabled = currentDate.getTime() > today.getTime(); // Disable future dates

      this.calendarDays.push({
        date: day,
        isOtherMonth: false,
        isSelected: isSelected,
        isToday: isToday,
        isDisabled: isDisabled,
        fullDate: currentDate,
      });
    }

    // Add next month's leading days to fill the grid
    const remainingDays = 42 - this.calendarDays.length; // 6 rows * 7 days
    for (let day = 1; day <= remainingDays; day++) {
      this.calendarDays.push({
        date: day,
        isOtherMonth: true,
        isSelected: false,
        isToday: false,
        isDisabled: false,
        fullDate: new Date(year, month + 1, day),
      });
    }
  }

  previousMonth() {
    this.currentCalendarDate = new Date(
      this.currentCalendarDate.getFullYear(),
      this.currentCalendarDate.getMonth() - 1,
      1,
    );
    this.selectedYear = this.currentCalendarDate.getFullYear();
    this.selectedMonth = this.currentCalendarDate.getMonth();
    this.generateCalendar();
  }

  nextMonth() {
    this.currentCalendarDate = new Date(
      this.currentCalendarDate.getFullYear(),
      this.currentCalendarDate.getMonth() + 1,
      1,
    );
    this.selectedYear = this.currentCalendarDate.getFullYear();
    this.selectedMonth = this.currentCalendarDate.getMonth();
    this.generateCalendar();
  }

  toggleMonthYearPicker() {
    this.showMonthYearPicker = !this.showMonthYearPicker;
  }

  onYearChange() {
    this.currentCalendarDate = new Date(
      this.selectedYear,
      this.selectedMonth,
      1,
    );
    this.generateCalendar();
    this.showMonthYearPicker = false;
  }

  onMonthChange() {
    this.currentCalendarDate = new Date(
      this.selectedYear,
      this.selectedMonth,
      1,
    );
    this.generateCalendar();
    this.showMonthYearPicker = false;
  }

  selectDate(day: any) {
    if (day.isDisabled || day.isOtherMonth) return;

    this.selectedDateValue = new Date(day.fullDate);
    this.generateCalendar();
  }

  selectDateAndClose(day: any) {
    if (day.isDisabled || day.isOtherMonth) return;

    this.selectedDateValue = new Date(day.fullDate);
    const formattedDate = this.formatDateToYYYYMMDD(
      this.selectedDateValue.toISOString(),
    );
    this.userForm.patchValue({ dateOfBirth: formattedDate });
    this.onDateOfBirthChange({ target: { value: formattedDate } });
    this.closeDatePicker();
  }

  confirmDateSelection() {
    if (this.selectedDateValue) {
      const formattedDate = this.formatDateToYYYYMMDD(
        this.selectedDateValue.toISOString(),
      );
      this.userForm.patchValue({ dateOfBirth: formattedDate });
      this.onDateOfBirthChange({ target: { value: formattedDate } });
      this.closeDatePicker();
    }
  }

  getCurrentMonthYear(): string {
    return `${this.monthNames[this.currentCalendarDate.getMonth()]} ${this.currentCalendarDate.getFullYear()}`;
  }

  getDisplayDate(): string {
    const dateValue = this.userForm.get('dateOfBirth')?.value;
    if (!dateValue) return '';

    return this.formatDateToDDMMYYYY(dateValue);
  }

  get verificationProfile(): VerificationProfile | null {
    return this.userData?.verification_profile ?? null;
  }

  private isTruthy(value: unknown): boolean {
    if (value === true || value === 1) {
      return true;
    }
    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      return normalized === 'true' || normalized === '1';
    }
    return false;
  }

  get isPanVerified(): boolean {
    return !!(
      this.verificationProfile?.pan_verified ||
      this.isTruthy((this.verificationProfile as any)?.['pan_verified'])
    );
  }

  get isRouteVerified(): boolean {
    const profile = this.verificationProfile || this.userData?.verification_profile;
    return !!(
      this.isTruthy(profile?.route_verified) ||
      this.isTruthy((profile as any)?.['route_verified']) ||
      this.isTruthy(this.businessData?.route_verified) ||
      this.isTruthy((this.businessData as any)?.['route_verified'])
    );
  }

  get isGstVerified(): boolean {
    return this.buyerVerificationService.isGstVerified(this.verificationProfile);
  }

  get isUdyamVerified(): boolean {
    return this.buyerVerificationService.isUdyamVerified(
      this.verificationProfile,
    );
  }

  get isShopLicenseVerified(): boolean {
    return this.buyerVerificationService.isShopLicenseVerified(
      this.verificationProfile,
    );
  }

  /** True when at least one of GSTIN / Udyam / Shop License or Route is verified. */
  get isBusinessVerified(): boolean {
    return (
      this.isGstVerified ||
      this.isUdyamVerified ||
      this.isShopLicenseVerified ||
      this.isRouteVerified
    );
  }

  canPlaceOrder(profile?: any): boolean {
    return this.buyerVerificationService.canPlaceOrder(profile ?? this.userData);
  }

  get areAllBusinessTypesVerified(): boolean {
    return (
      this.isGstVerified && this.isUdyamVerified && this.isShopLicenseVerified
    );
  }

  get isFullyBusinessVerified(): boolean {
    return (this.isPanVerified && this.isRouteVerified) || this.areAllBusinessTypesVerified;
  }

  get shouldShowBusinessVerificationButton(): boolean {
    // If route_verified is true and pan_verified is true, then it will not show the button
    if (this.isPanVerified && this.isRouteVerified) {
      return false;
    }
    if (this.areAllBusinessTypesVerified) {
      return false;
    }
    return true;
  }

  get businessVerificationLabel(): string {
    return this.isBusinessVerified ? 'Add Verification' : 'Verify Business';
  }

  getBusinessStepLabel(step: BusinessVerificationType): string {
    switch (step) {
      case 'gstin':
        return 'GSTIN';
      case 'udyam':
        return 'Udyam';
      default:
        return 'Shop License';
    }
  }

  /** Verified state of a type on the profile page. */
  isBusinessTypeVerified(step: BusinessVerificationType): boolean {
    return this.isStepVerifiedIn(step, this.verificationProfile);
  }

  getBusinessTypeSummary(step: BusinessVerificationType): string {
    return this.getStepSummaryIn(step, this.verificationProfile);
  }

  /** Verified state of a type inside the modal (uses the freshest fetched data). */
  isModalStepVerified(step: BusinessVerificationType): boolean {
    return this.isStepVerifiedIn(step, this.modalProfile);
  }

  getModalStepSummary(step: BusinessVerificationType): string {
    return this.getStepSummaryIn(step, this.modalProfile);
  }

  /** Other types the user can still verify from the current step. */
  get switchableBusinessSteps(): BusinessVerificationType[] {
    return this.businessVerificationTypes.filter(
      (type) =>
        type !== this.businessVerificationStep && !this.isModalStepVerified(type),
    );
  }

  private get modalProfile(): BuyerVerificationData | VerificationProfile | null {
    return this.businessData ?? this.verificationProfile;
  }

  private isStepVerifiedIn(
    step: BusinessVerificationType,
    profile: BuyerVerificationData | VerificationProfile | null,
  ): boolean {
    switch (step) {
      case 'gstin':
        return (
          this.buyerVerificationService.isGstVerified(profile) ||
          ((profile?.route === 'gst' ||
            (profile as any)?.['verification_route'] === 'gst') &&
            this.isTruthy(profile?.route_verified))
        );
      case 'udyam':
        return this.buyerVerificationService.isUdyamVerified(profile);
      default:
        return (
          this.buyerVerificationService.isShopLicenseVerified(profile) ||
          ((profile?.route === 'shop-license' ||
            profile?.route === 'shop_license' ||
            (profile as any)?.['verification_route'] === 'shop-license') &&
            this.isTruthy(profile?.route_verified))
        );
    }
  }

  private getStepSummaryIn(
    step: BusinessVerificationType,
    profile: BuyerVerificationData | VerificationProfile | null,
  ): string {
    if (!profile) return '';
    switch (step) {
      case 'gstin':
        return profile.selected_gstin ?? '';
      case 'udyam':
        return profile.uam_number ?? '';
      default: {
        if (!profile.shop_license_number) return '';
        const state = profile.shop_license_state
          ? `, ${this.formatShopLicenseStateLabel(profile.shop_license_state)}`
          : '';
        return `${profile.shop_license_number}${state}`;
      }
    }
  }

  private getFirstUnverifiedStep(): BusinessVerificationType | null {
    return (
      this.businessVerificationTypes.find(
        (type) => !this.isModalStepVerified(type),
      ) ?? null
    );
  }

  openBusinessVerificationModal(step?: BusinessVerificationType): void {
    if (!step && this.isPanVerified && this.isRouteVerified) {
      return;
    }

    this.showBusinessVerificationModal = true;
    this.businessVerificationError = '';
    this.gstinErrorMessage = '';
    this.udyamErrorMessage = '';
    this.shopLicenseErrorMessage = '';
    this.requestedBusinessStep = step ?? null;
    this.businessData = null;

    const profile = this.verificationProfile;

    if (profile?.pan_verified) {
      this.loadBusinessVerification();
      return;
    }

    this.businessVerificationStep = 'pan';
    this.businessPanNumber = profile?.pan_number ?? '';
    this.businessFullName =
      `${this.user?.first_name ?? ''} ${this.user?.last_name ?? ''}`.trim();
    this.resetBusinessVerificationTouched();
  }

  closeBusinessVerificationModal(): void {
    this.showBusinessVerificationModal = false;
    this.businessVerificationStep = null;
    this.requestedBusinessStep = null;
    this.autoFetchUdyam = false;
    this.businessData = null;
    this.businessLoading = false;
    this.gstinLoading = false;
    this.udyamLoading = false;
    this.shopLicenseLoading = false;
    this.businessVerificationError = '';
    this.gstinErrorMessage = '';
    this.udyamErrorMessage = '';
    this.shopLicenseErrorMessage = '';
  }

  switchBusinessStep(step: BusinessVerificationType): void {
    if (this.gstinLoading || this.udyamLoading || this.shopLicenseLoading) {
      return;
    }
    this.openBusinessStep(step);
  }

  goBackToGstinStep(): void {
    this.switchBusinessStep('gstin');
  }

  private resetBusinessVerificationTouched(): void {
    this.businessPanTouched = false;
    this.businessFullNameTouched = false;
    this.udyamNumberTouched = false;
    this.shopLicenseNumberTouched = false;
    this.shopLicenseStateTouched = false;
    this.shopLicenseCommencementDateTouched = false;
    this.shopLicenseDistrictTouched = false;
  }

  /** Reads linked documents, then opens the requested (or first unverified) step. */
  private loadBusinessVerification(): void {
    this.businessLoading = true;
    this.businessVerificationStep = null;
    this.businessVerificationError = '';
    this.businessFullName =
      `${this.user?.first_name ?? ''} ${this.user?.last_name ?? ''}`.trim();

    this.sub.add(
      this.buyerVerificationService.getStatus().subscribe({
        next: (data) => {
          this.businessLoading = false;
          this.applyBusinessData(data);
        },
        error: (error: Error) => {
          this.businessLoading = false;
          this.businessVerificationError = error.message;

          if (error.message.toLowerCase().includes('verify pan')) {
            this.businessVerificationStep = 'pan';
            return;
          }

          // Udyam and Shop License do not depend on the GSTIN list, so keep them usable.
          this.gstins = [];
          this.gstItems = [];
          this.udyamItems = [];
          this.udyamItem = null;
          const target =
            this.requestedBusinessStep ?? this.getFirstUnverifiedStep();
          if (target) {
            this.openBusinessStep(target);
            this.gstinErrorMessage = error.message;
          }
        },
      }),
    );
  }

  private applyBusinessData(data: BuyerVerificationData): void {
    this.setBusinessData(data);

      if (this.isPanVerified && this.isRouteVerified && !this.requestedBusinessStep) {
        this.getUserDetails();
        this.closeBusinessVerificationModal();
        return;
      }

      const target = this.requestedBusinessStep ?? this.getFirstUnverifiedStep();
      if (!target) {
        if (this.isPanVerified && this.isRouteVerified) {
          this.getUserDetails();
          this.closeBusinessVerificationModal();
        } else if (this.isPanVerified) {
          this.openBusinessStep('gstin');
        } else {
          this.businessVerificationStep = 'pan';
        }
        return;
      }

      this.openBusinessStep(target);

      if (this.autoFetchUdyam) {
        this.autoFetchUdyam = false;
        if (target === 'udyam' && !this.isModalStepVerified('udyam')) {
          this.fetchUdyamNumber();
        }
      }
    }

    /** Profile-row action: open the Udyam step and read available Udyam numbers. */
    fetchUdyamFromProfile(): void {
      this.autoFetchUdyam = true;
      this.openBusinessVerificationModal('udyam');
    }

  private fetchUdyamNumber(): void {
    if (this.udyamLoading) return;
    this.udyamLoading = true;
    this.udyamErrorMessage = '';

    this.sub.add(
      this.buyerVerificationService.fetchUdyam().subscribe({
        next: (data) => {
          this.udyamLoading = false;
          const previous = this.businessData;
          this.setBusinessData({
            ...previous,
            ...data,
            gstins: data.gstins?.length ? data.gstins : (previous?.gstins ?? []),
          });

          if (this.isModalStepVerified('udyam')) {
            this.getUserDetails();
          } else {
            this.prefillUdyamForm();
          }
          this.cdr.detectChanges();
        },
        error: (error: Error) => {
          this.udyamLoading = false;
          this.udyamErrorMessage = error.message;
          this.cdr.detectChanges();
        },
      }),
    );
  }

  private setBusinessData(data: BuyerVerificationData): void {
    this.businessData = data;
    this.gstins = data.gstins ?? [];
    this.gstItems = this.buyerVerificationService.filterGstDocuments(
      this.gstins,
    );
    this.udyamItems = this.buyerVerificationService.filterUdyamDocuments(
      this.gstins,
    );
    this.udyamItem =
      this.findUdyamItem(data.uam_number) ?? this.udyamItems[0] ?? null;
  }

  private openBusinessStep(step: BusinessVerificationType): void {
    this.businessVerificationError = '';
    this.gstinErrorMessage = '';
    this.udyamErrorMessage = '';
    this.shopLicenseErrorMessage = '';
    this.resetBusinessVerificationTouched();

    if (step === 'gstin') {
      this.selectedGstin = null;
    } else if (step === 'udyam') {
      this.prefillUdyamForm();
    } else {
      this.prefillShopLicenseForm();
    }

    this.businessVerificationStep = step;
    this.cdr.detectChanges();
  }

  private prefillUdyamForm(): void {
    const profile = this.modalProfile;
    this.udyamNumber = (
      this.udyamItem?.document_number ||
      this.getUdyamNumber(this.udyamItems[0]) ||
      profile?.uam_number ||
      ''
    )
      .trim()
      .toUpperCase();
    this.udyamItem = this.findUdyamItem(this.udyamNumber);
  }

  private prefillShopLicenseForm(): void {
    const profile = this.modalProfile;
    this.businessFullName =
      `${this.user?.first_name ?? ''} ${this.user?.last_name ?? ''}`.trim();
    this.shopLicenseNumber = profile?.shop_license_number ?? '';
    this.shopLicenseState =
      profile?.shop_license_state?.trim().toLowerCase() ?? '';
    this.shopLicenseCommencementDate = '';
    this.shopLicenseDistrict = '';
  }

  isBusinessPanValid(): boolean {
    return (
      this.isPanValid(this.businessPanNumber) &&
      !!this.businessFullName?.trim()
    );
  }

  isPanValid(pan: string): boolean {
    return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test((pan || '').toUpperCase());
  }

  onBusinessPanInput(event: Event): void {
    if (this.isPanVerified) return;
    const input = event.target as HTMLInputElement;
    this.businessPanNumber = input.value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, 10);
    input.value = this.businessPanNumber;
  }

  getBusinessPanError(): string {
    if (!this.businessPanTouched) return '';
    if (!this.businessPanNumber.trim()) return 'PAN number is required';
    if (!this.isPanValid(this.businessPanNumber)) {
      return 'Enter a valid PAN (e.g. ABCDE1234F)';
    }
    return '';
  }

  getBusinessFullNameError(): string {
    if (!this.businessFullNameTouched) return '';
    if (!this.businessFullName.trim()) return 'Full name is required';
    return '';
  }

  onBusinessPanSubmit(): void {
    this.businessPanTouched = true;
    this.businessFullNameTouched = true;
    this.businessVerificationError = '';

    if (!this.isBusinessPanValid() || this.businessLoading) return;

    this.businessLoading = true;

    this.sub.add(
      this.buyerVerificationService
        .verifyPan({
          pan_number: this.businessPanNumber.toUpperCase(),
          full_name: this.businessFullName.trim(),
          dob: '1990-01-01',
        })
        .subscribe({
          next: () => {
            this.sub.add(
              this.buyerVerificationService.fetchGstins().subscribe({
                next: (data) => {
                  this.businessLoading = false;
                  this.applyBusinessData(data);
                },
                error: (error: Error) => {
                  this.businessLoading = false;
                  this.businessVerificationError = error.message;
                },
              }),
            );
          },
          error: (error: Error) => {
            this.businessLoading = false;
            this.businessVerificationError = error.message;
          },
        }),
    );
  }

  isGstinActive(gstin: GstinItem): boolean {
    const row = gstin as unknown as Record<string, unknown>;
    const status = String(row['status'] || row['gstin_status'] || '')
      .trim()
      .toLowerCase();
    return status === 'active';
  }

  isGstinSelected(gstin: GstinItem): boolean {
    return this.getGstinNumber(this.selectedGstin) === this.getGstinNumber(gstin);
  }

  private getGstinNumber(item: GstinItem | null | undefined): string {
    const row = (item || {}) as unknown as Record<string, unknown>;
    return String(row['document_number'] || row['gstin'] || '').trim();
  }

  onGstinSelect(gstin: GstinItem): void {
    if (!this.isGstinActive(gstin)) return;
    this.selectedGstin = gstin;
    this.gstinErrorMessage = '';
    this.cdr.detectChanges();
  }

  onGstinSubmit(): void {
    const gstinNumber = this.getGstinNumber(this.selectedGstin);
    if (!gstinNumber || this.gstinLoading) return;
    this.gstinLoading = true;
    this.gstinErrorMessage = '';

    this.sub.add(
      this.buyerVerificationService
        .selectGstin(gstinNumber)
        .subscribe({
          next: () => {
            this.gstinLoading = false;
            this.getUserDetails();
            this.closeBusinessVerificationModal();
          },
          error: (error: Error) => {
            this.gstinLoading = false;
            this.gstinErrorMessage = error.message;
          },
        }),
    );
  }

  onUdyamInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.udyamNumber = input.value.replace(/\s/g, '').toUpperCase();
    input.value = this.udyamNumber;
    this.udyamItem = this.findUdyamItem(this.udyamNumber);
    this.udyamErrorMessage = '';
  }

  onUdyamSelect(): void {
    this.udyamNumber = this.udyamNumber.trim().toUpperCase();
    this.udyamItem = this.findUdyamItem(this.udyamNumber);
    this.udyamErrorMessage = '';
  }

  isUdyamValid(): boolean {
    return UDYAM_PATTERN.test(this.udyamNumber.trim().toUpperCase());
  }

  getUdyamNumberError(): string {
    if (!this.udyamNumberTouched) return '';
    if (!this.udyamNumber.trim()) {
      return this.udyamItems.length
        ? 'Select a Udyam number'
        : 'Udyam number is required';
    }
    if (!this.isUdyamValid()) {
      return 'Enter a valid Udyam number (e.g. UDYAM-MH-12-1234567)';
    }
    return '';
  }

  getUdyamNumber(item: GstinItem | null | undefined): string {
    const row = (item || {}) as unknown as Record<string, unknown>;
    return String(row['document_number'] || row['gstin'] || '')
      .trim()
      .toUpperCase();
  }

  get selectedUdyamItem(): GstinItem | null {
    return this.findUdyamItem(this.udyamNumber) ?? this.udyamItem;
  }

  private findUdyamItem(
    udyamNumber: string | null | undefined,
  ): GstinItem | null {
    const selected = (udyamNumber || '').trim().toUpperCase();
    if (!selected) return null;
    return (
      this.udyamItems.find((item) => this.getUdyamNumber(item) === selected) ??
      null
    );
  }

  onUdyamSubmit(): void {
    this.udyamErrorMessage = '';
    this.udyamNumberTouched = true;

    if (!this.isUdyamValid() || this.udyamLoading) return;

    this.udyamLoading = true;

    this.sub.add(
      this.buyerVerificationService
        .verifyUdyam({ udyam_number: this.udyamNumber.trim().toUpperCase() })
        .subscribe({
          next: () => {
            this.udyamLoading = false;
            this.getUserDetails();
            this.closeBusinessVerificationModal();
          },
          error: (error: Error) => {
            this.udyamLoading = false;
            this.udyamErrorMessage = error.message;
            this.cdr.detectChanges();
          },
        }),
    );
  }

  isShopLicenseValid(): boolean {
    return (
      !!this.shopLicenseNumber.trim() &&
      !!this.shopLicenseState.trim() &&
      !!this.shopLicenseCommencementDate &&
      !!this.shopLicenseDistrict.trim()
    );
  }

  getShopLicenseNumberError(): string {
    if (!this.shopLicenseNumberTouched) return '';
    if (!this.shopLicenseNumber.trim()) return 'Certificate number is required';
    return '';
  }

  getShopLicenseStateError(): string {
    if (!this.shopLicenseStateTouched) return '';
    if (!this.shopLicenseState.trim()) return 'State is required';
    return '';
  }

  getShopLicenseCommencementDateError(): string {
    if (!this.shopLicenseCommencementDateTouched) return '';
    if (!this.shopLicenseCommencementDate) {
      return 'Commencement date is required';
    }
    return '';
  }

  getShopLicenseDistrictError(): string {
    if (!this.shopLicenseDistrictTouched) return '';
    if (!this.shopLicenseDistrict.trim()) return 'District is required';
    return '';
  }

  formatShopLicenseStateLabel(state: string): string {
    return state.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  onShopLicenseSubmit(): void {
    this.shopLicenseErrorMessage = '';

    this.shopLicenseNumberTouched = true;
    this.shopLicenseStateTouched = true;
    this.shopLicenseCommencementDateTouched = true;
    this.shopLicenseDistrictTouched = true;

    if (!this.isShopLicenseValid() || this.shopLicenseLoading) return;

    this.shopLicenseLoading = true;

    this.sub.add(
      this.buyerVerificationService
        .verifyShopLicense({
          certificate_number: this.shopLicenseNumber.trim(),
          state: this.shopLicenseState.trim().toLowerCase(),
          name: this.businessFullName.trim(),
          commencement_date: this.shopLicenseCommencementDate,
          district: this.shopLicenseDistrict.trim(),
        })
        .subscribe({
          next: () => {
            this.shopLicenseLoading = false;
            this.getUserDetails();
            this.closeBusinessVerificationModal();
          },
          error: (error: Error) => {
            this.shopLicenseLoading = false;
            this.shopLicenseErrorMessage = error.message;
            this.cdr.detectChanges();
          },
        }),
    );
  }

  get businessVerificationModalTitle(): string {
    const step = this.businessVerificationStep;
    if (step && step !== 'pan' && this.isModalStepVerified(step)) {
      return `${this.getBusinessStepLabel(step)} Verified`;
    }
    switch (step) {
      case 'gstin':
        return 'Select GSTIN';
      case 'udyam':
        return 'Udyam Verification';
      case 'shop-license':
        return 'Shop License Details';
      default:
        return 'Business Verification';
    }
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent): void {
    // Only close desktop dropdown on outside click (not mobile bottom sheet)
    if (this.showDatePicker && window.innerWidth >= 768) {
      const target = event.target as HTMLElement;
      const clickedInside =
        this.datePickerContainer?.nativeElement?.contains(target) ||
        target.closest('.date-picker-input-container');

      if (!clickedInside) {
        this.closeDatePicker();
      }
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    // Clear timers to prevent memory leaks
    if (this.otpInterval) {
      clearInterval(this.otpInterval);
    }
    if (this.emailOtpInterval) {
      clearInterval(this.emailOtpInterval);
    }
  }
}
